import React, { useMemo } from 'react';
import { ForgeIcon, ForgeSelect } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';
import { HierarchyColumnConfig } from 'common/visualizations/vif';

type RowGroupSelectProps = {
  currentRowGroup: string;
  groupingColumnNames: string[];
  selectedColumnGroupings: HierarchyColumnConfig[];
  onChange: (event: CustomEvent) => void;
};

const scope = 'shared.components.advanced_totaling.modal';

const RowGroupSelect = (props: RowGroupSelectProps) => {
  const { currentRowGroup, groupingColumnNames, onChange, selectedColumnGroupings } = props;
  const dropdownOptions = useMemo(
    () =>
      groupingColumnNames.map((groupingColumnName, index) => ({
        label: groupingColumnName,
        value: selectedColumnGroupings[index].columnName,
      })),
    [groupingColumnNames, selectedColumnGroupings],
  );
  return (
    <span className="row-group-select--container">
      <ForgeSelect
        density="small"
        labelAlignment="start"
        labelPosition="inset"
        popoverIcon={false}
        theme="primary"
        variant="plain"
        onChange={onChange}
        options={dropdownOptions}
        value={currentRowGroup}
      >
        <span slot="start">{`${I18n.t('row_group', { scope })}`}</span>
        <ForgeIcon slot="end" name="chevron_down" icon_type="button" theme="primary" />
      </ForgeSelect>
    </span>
  );
};

export default RowGroupSelect;
